import { render, staticRenderFns } from "./VimeoEmbedCodeBtn.vue?vue&type=template&id=8d6033aa&"
import script from "./VimeoEmbedCodeBtn.vue?vue&type=script&lang=js&"
export * from "./VimeoEmbedCodeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports